export default function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return !!getIn(nonNullGetFormState(state), form + ".submitSucceeded");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/selectors/hasSubmitSucceeded.js
// module id = 1368
// module chunks = 25